<template>
  <div
    class="fontFamily-setting"
    v-if="boxData.judgeBox"
    :style="{
      top: boxData.fix.y + 'px',
      left: boxData.fix.x + 'px',
      'z-index': boxData.Zindex,
    }"
    @mousedown.stop
    @click.stop
  >
    <search
      v-model="fontKeyword"
      :isFocused="isFontFocused"
      placeholderText="搜索字体"
      @onFocus="fontFocusAction"
      @searchAction="searchFont"
    ></search>
    <div
      v-if="!isFontFocused"
      class="fontFamily-header"
      @mousedown="
        moveStart(
          $event,
          boxData.data.from === 'textSetting_Panel' ? false : true
        )
      "
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{
        cursor: boxData.data.from === 'textSetting_Panel' ? 'auto' : 'move',
      }"
    >
      <div v-for="(v, i) in headerArr" :key="i" :class="{ active: v.active }">
        <div @click="changeSetType(v, i)">{{ v.name }}</div>
      </div>
    </div>
    <div class="fontFamily-container" :style="{
          height:  headerArr[1].active && !isFontFocused ? '278px':'310px',
        }">
      <div
        class="brand-list"
        :style="{
          left: headerArr[1].active && !isFontFocused ? '0' : '100%',
          height: headerArr[1].active && !isFontFocused ? '100%' : '0',
        }"
      >
        <template v-if="brandList.length">
          <div
            class="font-detail"
            v-for="(font, f) in brandList"
            :key="'brand' + f"
            @click="loadFonts(font)"
          >
            <div
              class="font-thumbnail"
              :style="{
                backgroundImage: `url(${$handleAssetsUrl((font || {}).fontUrl)})`,
              }"
            ></div>
          </div>
        </template>
        <div v-else class="no-brand-list empty">
          <p v-if="!UserTeamInfo">品牌字体为团队功能</p>
          <p v-else>当前暂无品牌字体</p>
          <a target="_blank" href="/dashboard/team/brand/fonts">去了解</a>
        </div>
      </div>
      <div
        v-if="headerArr[1].active && !isFontFocused"
        class="upload-font-tips"
        @click="onGoFont"
      >
        现已支持上传字体，去看看！
      </div>
      <div
        class="font-list-outer"
        :style="{
          left: headerArr[0].active || isFontFocused ? '0' : '-100%',
          height: headerArr[0].active || isFontFocused ? 'auto' : '0',
        }"
      >
        <template v-if="!isFontFocused">
          <div class="fontFamily-cate">最近使用</div>
          <div
            class="font-list"
            v-for="(item, index) in recentUsedList"
            :key="'recentUsedList' + index"
          >
            <div class="font-detail" @click="loadFonts(item, 'recent')">
              <div
                class="font-thumbnail"
                :style="`background-image: url(${$handleAssetsUrl(
                  (item || {}).fontUrl
                )})`"
              ></div>
            </div>
          </div>
          <div class="fontFamily-cate">全部字体</div>
        </template>
        <div class="font-list" v-if="renderFontList.length">
          <template v-for="(font, f) in renderFontList">
            <div
              class="font-detail"
              :class="{ isSelected: getIsSelected(font) }"
              v-if="
                font.payType !== 1 ||
                font.isPay ||
                boxData.data.from !== 'wordCloud'
              "
              :key="'font' + f"
              @click="loadFonts(font)"
            >
              <div
                class="font-thumbnail"
                :style="{
                  backgroundImage: `url(${$handleAssetsUrl((font || {}).fontUrl)})`,
                }"
              ></div>
              <div v-show="font.status === 1">
                <i class="el-icon-loading"></i>
              </div>

              <div class="font-payType hasPay" v-if="font.isPay">
                <el-tooltip
                  effect="dark"
                  :content="`(${font.delayTime})到期`"
                  placement="top"
                >
                  <div></div>
                </el-tooltip>
              </div>
              <div
                class="font-payType" v-else-if="font.payType === 4"
                :class="[getBadgeClassName(font.payType, IsOldUser ? 'noPay' : 'enterpriseS')]"
              >
                <div></div>
              </div>
              <div
                class="font-payType"
                :class="getBadgeClassName(font.payType, 'noPayCompany')"
                v-else-if="font.payType === 6"
              >
                <div></div>
              </div>
              <div
                v-show="UserMsg.payForMaterial !== 1"
                class="font-payType noPayNumber"
                v-else-if="font.payType === 1"
              >
                <div>{{ `￥${parseInt(font.price || 0)} 起` }}</div>
              </div>
            </div>
          </template>
        </div>
        <div class="empty" v-else-if="loadingStatus !== 1">
          <div class="icon"></div>
          <p>找不到任何字体哦</p>
        </div>
      </div>
      <div v-show="loadingStatus === 1">
        <i class="el-icon-loading" style="font-size: 26px"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popup from "../mixins/popup";
import search from './search.vue';
import vipBadge from '@/components/mixins/vipBadge';

export default {
  components: { search },
  mixins: [popup, vipBadge],
  data() {
    return {
      headerArr: [
        { type: "fontList", name: "字体库", active: true },
        { type: "fontBrand", name: "品牌", active: false },
      ],
      isBuyFont: false,
      fontList: [],
      spriteType: "fontFamily",
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        moveoks: false, // 拖动判读啊数据
        oldMove: {
          // 计算移动增量
          x: 0,
          y: 0,
        },
        fix: {
          // 弹窗位置
          x: 0,
          y: 0,
        },
      },
      loadingStatus: 0, //加载状态 0为加载完毕，1为加载中，2为没有更多数据
      sOfPage: 999999, // 一次性取所有数据
      pIndex: 1,
      fristIn: 0,
      coupons: 0,
      setIndex: -1,
      fontKeyword: '',
      isFontFocused: false,
      renderFontList: [],
      recentUsedList: []
    };
  },
  // props: ['dataMsg', 'boxDatas'],
  computed: {
    ...mapGetters(["TOOL", "downFonts", "brandList", "UserMsg", "UserTeamInfo", 'IsOldUser']),
    ...mapGetters({
      subtitleObj: "subtitle/subtitleObj",
    }),
  },
  watch: {
    "UserMsg": function (val) {
      const name = `recentUsedFont${ val.id }`;
      if (!window.localStorage.getItem(name)) {
        // 将方正黑体设置为默认字体
        const fangZheng = JSON.stringify([{
          id: "e629e28b-df72-4767-a6d3-695c50c841e7",
          value: "2018-5-16/1526467728442.TTF",
          fontUrl: "2019-1-19/7ba3882f-d9e7-4e2a-8067-f03835e65403nail.png",
          label: "方正黑体",
          payType: 0,
          isPay: false,
          price: "0.00",
          delayTime: null,
          status: 2
        }]);
        window.localStorage.setItem(name, fangZheng);
      }
      this.recentUsedList = JSON.parse(window.localStorage.getItem(name));
    },
    "boxData.judgeBox": function (val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "fontFamily");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (
        (this.TOOL && this.boxData.judgeBox) ||
        (this.subtitleObj && this.boxData.judgeBox)
      ) {
        // 打开的操作
        this.boxData.data = this.dataMsg.fontFamily;
        this.sprite = (this.dataMsg.setting_Text || this.boxData.data).sprite;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.fix.x = this.dataMsg.fontFamily.posx;
        this.boxData.fix.y = this.dataMsg.fontFamily.posy + 28;
        this.fontFamily = this.boxData.data.fontFamily;
        if (this.setIndex > -1) {
          this.fontList.splice(
            this.downFonts.length - 1,
            0,
            ...this.fontList.splice(this.setIndex, 1)
          );
          this.setIndex = -1;
        }
        (this.isBuyFont || !this.fristIn) && this.getFontData(true);
        this.fristIn++;
        this.isBuyFont = false;
        this.coupons = 0;
        this.$http
          .get("/api/user/coupon", {
            params: {
              type: 1,
              goodsType: 14,
            },
          })
          .then((res) => {
            let num = res.data.total || 0;
            this.coupons += num;
          })
          .catch((err) => console.warn(err))
          .then(() => {
            this.$http
              .get("/api/user/coupon", {
                params: {
                  type: 1,
                  goodsType: 15,
                },
              })
              .then((res) => {
                let num = res.data.total || 0;
                this.coupons += num;
              })
              .catch((err) => console.warn(err));
          });
      } else {
        this.$bus.emit("fontFamilyClose", this.boxData.data.from);
      }
    },
  },
  created() {
    const name = `recentUsedFont${ this.UserMsg.id }`;
    this.recentUsedList = JSON.parse(window.localStorage.getItem(name));
  },
  mounted() {
    this.$bus.on("fontPaySuccess", (data) => {
      this.getFontData(true);
    });
    if (this.checkChrome() === -1) {
      document.fonts.onloadingdone = () => {
        if (this.font) {
          this.font.status = 2;
          this.updateFontFamily(true);
        }
      };
      document.fonts.onloadingerror = (e) => {
        if (this.font && this.font.status === 1) {
          this.font.status = 0;
          this.$message.error({
            message: "字体下载失败",
          });
        }
      };
    }
  },
  methods: {
    searchFont(val) {
      if (val === '') {
        this.renderFontList = this.fontList;
        return;
      }
      this.renderFontList = this.fontList.filter(item => {
        return item.label.indexOf(val) !== -1;
      });
    },
    fontFocusAction(bol) {
      this.isFontFocused = bol;
    },
    onGoFont() {
      window.open(window.origin + "/dashboard/team/brand/fonts", '_blank');
    },
    searchAction(val) {
    },
    changeSetType(v, i) {
      let j = (i + 1) % 2;
      this.headerArr[i].active = true;
      this.headerArr[j].active = false;
    },
    getIsSelected(font) {
      let { boxData, dataMsg } = this;
      return (
        font.value ===
        (boxData.data.from
          ? (boxData.data.refFont || {}).value
          : (((dataMsg.setting_Text || boxData.data).sprite || {}).font || {})
            .fontFamilyUrl)
      );
    },
    setRecentUseFont(font) {
      const name = `recentUsedFont${ this.UserMsg.id }`;
      const exitObj = this.recentUsedList.findIndex((item) => item.id === font.id);
      if (exitObj !== -1) {
        this.recentUsedList.splice(exitObj, 1);
      }
      this.recentUsedList.unshift(font);
      if (this.recentUsedList.length >= 5) {
        this.recentUsedList = this.recentUsedList.splice(0, 5);
      }
      window.localStorage.setItem(name, JSON.stringify(this.recentUsedList));
    },
    loadFonts(font, type) {
      if (type === 'recent') {
        font = this.renderFontList.find((item) => item.value === font.value);
      }
      this.font = font;
      this.isFontFocused = false;
      if (font.status === 2) {
        this.setRecentUseFont(font);
        this.updateFontFamily(false);
        return;
      } else if (font.status === 1) {
        return;
      }
      font.status = 1;
      let _this = this;

      if (this.checkChrome() !== -1) {
        var bitterFontFace = new FontFace(
          font.value.split("/").pop(),
          `url(${ this.$handleAssetsUrl(font.value) })`
        );
        document.fonts.add(bitterFontFace);
        bitterFontFace
          .load()
          .then(() => {
            font.status = 2;
            this.updateFontFamily(true);
            this.setRecentUseFont(font);
          })
          .catch(() => {
            font.status = 0;
            this.$message.error({
              message: "字体下载失败",
            });
          });
      } else {
        return new Promise((resolve, reject) => {
          fetch(_this.$handleAssetsUrl(font.value)).then(function (res) {
            if (!res.ok) {
              // console.error('load font "' + font.value + '" fail:', res);
              this.$message.error({
                message: "字体下载失败",
              });
              return;
            }
            // 添加font-face
            var style =
              '<style type="text/css">\n' +
              "@font-face {" +
              'font-family: "' +
              font.value.split("/").pop() +
              '";' +
              'src: url("' +
              res.url +
              '");';
            $("head").prepend(style);
            // 下载完成后隐藏下载按钮
            font.status = 2;
            this.setRecentUseFont(font);
            this.updateFontFamily(true);
            resolve();
          });
        });
      }
    },
    isSupportFontFamily(f) {
      // 判断用户操作系统是否安装某字体
      if (typeof f != "string") {
        return false;
      }
      var h = "Arial";
      if (f.toLowerCase() == h.toLowerCase()) {
        return true;
      }
      var e = "a";
      var d = 100;
      var a = 100,
        i = 100;
      var c = document.createElement("canvas");
      var b = c.getContext("2d");
      c.width = a;
      c.height = i;
      b.textAlign = "center";
      b.fillStyle = "black";
      b.textBaseline = "middle";
      var g = function (j) {
        b.clearRect(0, 0, a, i);
        b.font = d + "px " + j + ", " + h;
        b.fillText(e, a / 2, i / 2);
        var k = b.getImageData(0, 0, a, i).data;
        return [].slice.call(k).filter(function (l) {
          return l != 0;
        });
      };
      return g(h).join("") !== g(f).join("");
    },
    getFontData(init) {
      let isPush = true;
      if (init) {
        this.pIndex = 1;
        this.fontList = [].concat(this.downFonts);
      }
      this.loadingStatus = 1;
      this.$http
        .get(
          `/api/common/material?style=1&type=6&sOfPage=${ this.sOfPage }&fPage=${ this.sOfPage }&pIndex=${ this.pIndex }`
        )
        .then((res) => {
          if (res.data.data && res.data.data.length !== 0) {
            this.$bus.emit("fontFamily.getFontsFirst", res.data.data);
            res.data.data.forEach((font) => {
              isPush = true;
              for (let i in this.downFonts) {
                if (font.url === this.downFonts[i].value) {
                  isPush = false;
                  break;
                }
              }
              isPush &&
                this.fontList.push({
                  id: font.id,
                  value: font.url,
                  fontUrl: (font || {}).fontUrl,
                  label: font.title,
                  payType: font.payType,
                  isPay: font.tt ? true : false,
                  price: font.price,
                  delayTime: font.tt && this.getDelayTime(font.tt.createTime),
                  status: 0,
                });
            });
            this.renderFontList = this.fontList;
            this.loadingStatus = 0;
          } else {
            this.loadingStatus = 2;
          }
        })
        .catch((err) => {
          this.loadingStatus = 0;
        });
    },
    handleScroll(e) {
      if (this.loadingStatus != 0 || this.fontList.length < this.sOfPage)
        return;
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = 318;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.pIndex++;
        this.getFontData();
      }
    },
    handleBrandScroll(e) { },
    buyFont(font) {
      let url = `/payResource?fontId=${ font.id }`;
      // if (this.coupons > 0) {
      //   url += '&coupon=1'
      // }
      window.open(url);
      this.$bus.emit("FeaturesPop_vue", {
        name: "vipPayment",
        msg: "请在相应的付款页面进行操作",
        btnClose: "遇到问题",
        btnMsg: "付款成功",
        msgType: 3,
        type: 2,
        fontId: font.id,
      });
      this.isBuyFont = true;
    },
    getDelayTime(time) {
      if (!time) return;
      let now = new Date(time * 1000);
      let fu = now.setFullYear(now.getFullYear() + 1);
      fu = new Date(fu).toISOString();
      fu = fu.split(/-|T/);
      fu.length = 3;
      return fu.join(".");
    },
    close() {
      //FeaturesPop_close_vue
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "fontFamily",
        type: 1,
      });

      try {
        this.boxData.data &&
          this.boxData.data.source &&
          this.boxData.data.source.toggleMask(false);
      } catch (err) {
        console.log(" close -> err", err);
      }
    },
    updateFontFamily(down) {
      if (down) {
        let downFonts = [].concat(this.downFonts).concat(this.font);
        this.setIndex = this.fontList.findIndex((font) => {
          return font.value === this.font.value;
        });
        this.$store.commit("toggle_downFonts", downFonts);
        this.isBuyFont = true;
      }
      this.$bus.emit("font", this.font, this.boxData.data.from); // 已下载
    },
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
      // e.preventDefault();
    },
    checkChrome() {
      if (navigator.userAgent) {
        return navigator.userAgent.indexOf("Chrome");
      } else {
        return -1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fontFamily-setting {
  position: fixed;
  top: 0;
  left: 0;
  width: 226px;
  height: 384px;
  z-index: 35;
  background: #fff;
  overflow: hidden;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #474261;
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  box-sizing: border-box;
}

.fontFamily-header {
  width: 226px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #d4d4e7;

  div div {
    width: 43px;
    height: 34px;
    border-bottom: 1px solid transparent;
    line-height: 36px;
    font-size: 12px;
    font-weight: bold;
    color: #737596;
    cursor: pointer;
  }

  .active div {
    border-bottom: 1px solid #5778fb;
  }
}

.fontFamily-container {
  // position: relative;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 316px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .upload-font-tips {
    position: absolute;
    bottom: 0;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background-color: #f8f8fc;
    width: 100%;
  }
}
.font-list-outer,
.brand-list {
  position: relative;
  top: 0;
  transition: all 0.3s;
  width: 100%;
}
.fontFamily-cate {
  width: 100%;
  background-color: #edeff8;
  line-height: 26px;
  color: #737596;
  font-size: 12px;
}
.empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 306px;
  .icon {
    width: 101px;
    height: 90px;
    background-image: url("../../../static/img/empty.png");
    background-position: 0 0;
    background-size: 100% 100%;
  }
  p {
    margin-top: 10px;
    line-height: 16px;
    font-size: 14px;
    color: #474261;
  }
}

.brand-list {
  height: 350px;
  .no-brand-list {
    width: 100%;
    height: 100%;
    a {
      color: #113df5;
    }
  }
}

.font-detail {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1px;
  padding: 0 12px 0 14px;
  width: 100%;
  height: 34px;
  cursor: pointer;
  &:hover {
    background: linear-gradient(270deg, #ffffff 0%, #f2f3f7 100%);
  }

  &.isSelected {
    background-color: #f2f3f7;
  }
}

.font-thumbnail {
  width: 120px;
  height: 34px;
  overflow: hidden;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: contain;
}

.font-payType {
  width: 50px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.font-payType.hasPay {
  div {
    width: 50px;
    height: 14px;
    background-image: url("../../../static/svg/payTypeSubscript/bought50x14.svg");
  }
}
.font-payType.noPay {
  div {
    width: 36px;
    height: 14px;
    background-image: url("../../../static/svg/payTypeSubscript/vip36x14.svg");
  }
}
.font-payType.noPayCompany {
  div {
    width: 50px;
    height: 14px;
    background-image: url("../../../static/svg/payTypeSubscript/companyVip50x14.svg");
  }
}
.font-payType.enterpriseS {
  div {
    width: 50px;
    height: 16px;
    // background-image: url('../../../static/svg/payTypeSubscript/enterpriseS.png');
    background-image: url('../../../static/svg/payTypeSubscript/enterpriseSVIP.svg');
  }
}
.font-payType.noPayNumber {
  div {
    font-size: 10px;
    color: #ffffff;
  }
  background-color: #f5535a;
}
.font-payType.pro {
  div {
    width: 30px;
    height: 18px;
    background-image: url(../../assets/pro.png);
  }
}
.font-payType.proPlus {
  div {
    width: 32px;
    height: 18px;
    background-image: url(../../assets/proPlus.png);
  }
}
.isSelected {
  background-color: #e9ebf4;

  .noPay {
    color: #fff;
  }
}

.fontFamily-foot {
  width: 226px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #737596;
  background-color: #f2f3f7;
}
</style>




// WEBPACK FOOTER //
// src/components/popups/fontFamily.vue